import { PaymentState } from 'my-account/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { Transaction } from './transaction';

export class TransactionCollection extends ModelBase {
    public static storeName: string = 'transactionCollection';
    public paymentTransactions: Transaction[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'paymentTransactions',
            model: Transaction
        }];
    }

    public get pastDueTransaction(): Transaction {
        return this.paymentTransactions.find((transaction: Transaction) => transaction.state === PaymentState.PAST_DUE);
    }

    public get estimatedTransaction(): Transaction {
        return this.paymentTransactions.find((transaction: Transaction) => transaction.state === PaymentState.ESTIMATED);
    }

    public get nextPaymentTransaction(): Transaction {
        return this.paymentTransactions.find((transaction: Transaction) => transaction.state === PaymentState.PENDING);
    }

    public get getPaidTransactions(): Transaction[] {
        return this.paymentTransactions.filter((transaction: Transaction) => transaction.state === PaymentState.PAID);
    }
}
